//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import HrContractStructureCreate from '@/views/HumanResource/HrContractStructure/HrContractStructureCreate'
import HrContractStructureList from '@/views/HumanResource/HrContractStructure/HrContractStructureList'
import HrContractStructureUpdate from '@/views/HumanResource/HrContractStructure/HrContractStructureUpdate'

//
export default {
  path: 'contract_structures',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'contract-structure-list',
      component: HrContractStructureList,
    },
    {
      path: 'create',
      name: 'contract-structure-create',
      component: HrContractStructureCreate,
      meta: {
        title: 'Crear contrato',
      },
    },
    {
      path: ':id',
      name: 'contract-structure-update',
      component: HrContractStructureUpdate,
      meta: {
        title: 'Detalle del contrato',
      },
    },
  ],
  meta: {
    title: 'Contratos tipo',
  },
}
